import { cordovaWindow } from "../../cordova";

export const getBraintreeApplePayAvailable = () =>
    new Promise<boolean>((resolve, reject) =>
        cordovaWindow.BraintreeDevicePayments.getApplePayAvailable(({ available }) => resolve(available), reject)
    );
